import { ElementRef, OnInit } from '@angular/core';
import { Directive } from '@angular/core';
import { FontTypeEnum } from '../model/enums/FontTypeEnum';
import { SessionService } from '../session-service.service';

@Directive({
  selector: '[appConfigSettingsSecondTitle]'
})
export class ConfigSettingsSecondTitleDirective implements OnInit {

  FontTypeEnum = FontTypeEnum;
  constructor(private elementRef: ElementRef, private sessionService: SessionService) { }

  ngOnInit(): void {
    this.elementRef.nativeElement.style.color = this.sessionService.getConfigSettingsDto().fontColor;
    this.elementRef.nativeElement.style.fontFamily = FontTypeEnum[this.sessionService.getConfigSettingsDto().fontType] || FontTypeEnum.Sun;
    this.elementRef.nativeElement.style.fontSize = this.sessionService.getConfigSettingsDto().fontSizeH2 + 'px';
  }

}
